<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.applications') }} > {{ $t('sidebar.operations') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BaseInstallApps
        :title="$t('apps.installapp.message.operationtitle')"
        :apps="apps"
        :installed="getShopInstalledApps"
        :pricing="pricing"
        @onClickInstallApp="handleOpenModalInstallApp"
      />

      <BaseModalInstallApp
        :id="MODAL_INSTALL_APP"
        :selectedApp="selectedApp"
        :installed="getShopInstalledApps"
        :pricing="pricing"
        :isSubmitting="isSubmitting"
        @onClose="handleCloseModal"
        @onApply="handleApply"
        @onUninstall="handleUninstall"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import BaseInstallApps from '@/components/base/BaseInstallApps.vue'
import BaseModalInstallApp from '@/components/base/BaseModalInstallApp.vue'
import sidebarModule from './../../sidebarModule'
import installAppMixin from '@/mixins/installApp'

export default {
  components: {
    BaseInstallApps,
    BaseModalInstallApp,
  },
  mixins: [installAppMixin],
  computed: {
    apps () {
      const showAppIds = [3, 4]
      return this.getApps.filter(app => showAppIds.indexOf(app.app_id) >= 0)
    },
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.installapp.title'),
      current: {
        app_name: 'installapp',
        app_id: null,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 2,
    })
  },
  async mounted () {
    await this.getPricing()
    this.loading = false
    this.showFinish(this.$Progress)
  },
}
</script>

<style scoped>
  #content .content {
    padding-top: 18px;
    padding-left: 15px;
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/applications/category/Operations.vue